import { COLORS } from '@/common/constants';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  status: any;
  load: any;
  setOpen?: any;
  canCancel?: boolean;
}

export const GeneralHeading: FC<IProps> = ({
  status,
  load,
  setOpen,
  canCancel,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex-h-center-between mb-6">
      <h3 className="text-lg font-medium">{t('general.data')}</h3>
      <div className="flex items-center gap-4">
        {/* {load?.cancel_request ? (
          <>
            <p className="text-lg font-medium">{t('request.delete.status')}:</p>
            <Badge
              className={cn(
                ' text-[11px] py-[1px] text-white',
                COLORS_CANCEL.find(
                  (c) => c.key === load?.cancel_request?.status,
                )?.color || 'bg-gray-400',
              )}
            >
              {t(
                `${COLORS_CANCEL.find((c) => c.key === load?.cancel_request?.status)?.name}`,
              )}
            </Badge>
          </>
        ) : (
          canCancel && (
            <Button
              onClick={() => setOpen(true)}
              variant="outline"
              className="text-red hover:text-red flex items-center gap-1"
            >
              <TrashIcon className="w-4 h-4 stroke-red" />
              {t('request.delete')}
            </Button>
          )
        )} */}

        <p className="text-lg font-medium">
          {t('id.number')}:
          <span className={cn(load?.number ? 'text-green-500' : '', 'ml-2')}>
            {load?.number ? load?.number : '----'}
          </span>
        </p>
        <Badge
          className={cn(
            ' text-[11px] py-[1px] text-white',
            COLORS?.find((c) => c.key === status)?.color || 'bg-gray-400',
          )}
        >
          {t(
            `${COLORS?.find((c) => c.key === status)?.name || 'not.information'}`,
          )}
        </Badge>
      </div>
    </div>
  );
};
